export const windowLabel = (from, to) => {
  if (!from || !to) return "All day";
  return to < from ? `${from} – ${to} next day` : `${from} – ${to}`;
};

export const windowError = (from, to) => {
  if (Boolean(from) !== Boolean(to)) return "Give both an on time and an off time, or leave both empty to show it all day";
  if (from && from === to) return "The on and off times must differ";
  return null;
};

export const liveNow = (section) => Boolean(section.is_active && section.in_window_now);
